import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d4c30830"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "BOX" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"flex-ct content\" data-v-d4c30830><div class=\"info-box\" data-v-d4c30830><div data-v-d4c30830><div class=\"title\" data-v-d4c30830>科室地址</div><div data-v-d4c30830> 复旦大学附属中山医院西院区8号楼12楼81病区 </div></div><div data-v-d4c30830><div class=\"title\" data-v-d4c30830>肾移植普通门诊地址</div><div data-v-d4c30830> 复旦大学附属中山医院西院区20号楼2楼1区129号诊室（2楼候诊1区） </div></div><div data-v-d4c30830><div class=\"title\" data-v-d4c30830>电话</div><div data-v-d4c30830>021-64041990</div></div><div data-v-d4c30830><div class=\"title\" data-v-d4c30830>门诊时间</div><div data-v-d4c30830> 周一下午、周二下午、周三下午、周四下午、周五下午（节假日除外） </div></div></div><div class=\"map-box\" data-v-d4c30830><div id=\"map\" class=\"map\" data-v-d4c30830></div></div></div>", 1)
const _hoisted_3 = [
  _hoisted_2
]

import { onMounted, ref } from "vue";
import AMapLoader from "@amap/amap-jsapi-loader";


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const map = ref<any>(null);
onMounted(async () => {
  AMapLoader.load({
    key: "98da2fba2ef1027023a833f2fbec7af7",
    version: "2.0", // 指定要加载的 JSAPI 的版本
    plugins: ["AMap.ToolBar"], // 插件列表
  }).then((AMap) => {
    map.value = new AMap.Map("map", {
      center: [121.453476, 31.199004], // 中心点经纬度
      zoom: 16, // 缩放级别
      viewMode: "2D", //设置地图模式
    });

    //添加工具条控件，工具条控件集成了缩放、平移、定位等功能按钮在内的组合控件
    map.value.addControl(new AMap.ToolBar());

    //创建点标记
    new AMap.Marker({
      map: map.value,
      position: [121.453476, 31.199004],
    });
  });
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
}
}

})